import React from 'react';
import {css} from "@emotion/css";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {Helmet} from "react-helmet";
import {RouteInfo} from "../../route/RouteHelper";

const ReleaseDocuments = () => {
    return (
        <>
            <Helmet>
                <title>{RouteInfo.ReleaseDocuments.name}</title>
            </Helmet>
            <section
                className={css`
                  padding: 26px 0;
                  overflow: hidden;
                `}>
                <ul className="page-title-bread-crumb-container">
                    <li>اسناد</li>
                    <li>تاریخچه انتشار</li>
                </ul>

                <section className={
                    css`
                      display: flex;
                      flex-direction: column;
                      gap: 16px;
                    `}>
                    {
                        releaseDocumentsInfo.map((item, index) => {
                            return <div
                                key={index}
                                className={css`display: flex;
                                  flex-direction: column;
                                  margin-top: 40px;
                                  gap: 16px`}>
                                <div className={css`display: flex;
                                  gap: 16px;`}>
                            <span className={css`
                              background: var(--color-primary-highlight);
                              padding: 16px;
                              border-radius: var(--default-border-radius);
                              color: var(--color-primary);
                              font-size: var(--text-size-medium);
                            `}>
                                {item.version}
                            </span>

                                    <div className={css`display: flex;
                                      flex-direction: column;
                                      gap: 8px`}>
                                <span className={
                                    css`font-size: var(--text-size-medium);
                                      color: var(--color-text);`}>{item.title}</span>
                                        <span className={
                                            css`font-size: var(--text-size-default);
                                              color: var(--color-text);`}>{item.description}</span>
                                    </div>
                                </div>
                                <div className={`default-card-container-background-style`}>
                                    {
                                        item.documents.map((document, documentIndex) => {
                                            return <Accordion>
                                                <AccordionSummary expandIcon={<ExpandMoreIcon/>}>
                                        <span className={css`font-size: var(--text-size-medium);
                                          color: var(--color-text);`}>{document.title}</span>
                                                </AccordionSummary>
                                                <AccordionDetails>
                                                    <ul className={css`list-style-type: none;`}>
                                                        {document.description.map((item, index) => {
                                                            return <li
                                                                className={css`padding: 0 0.25rem 0.5rem .25rem`}>
                                                                    <span
                                                                        key={index}
                                                                        className={css`font-size: var(--text-size-default);
                                                                          color: var(--color-text);`}>
                                                                        {item}
                                                                    </span>
                                                            </li>
                                                        })}
                                                    </ul>
                                                </AccordionDetails>
                                            </Accordion>
                                        })
                                    }
                                </div>
                            </div>
                        })
                    }
                </section>
            </section>
        </>


    )
}

export default ReleaseDocuments;

const releaseDocumentsInfo =
    [
        {
            title: "بروزرسانی 21 آبان 1401",
            version: "نسخه 1.01",
            description: <span>ایجاد پنل و اتصالات مقدمات</span>,
            documents: [
                {
                    title: "⭐ ویژگی های جدید",
                    description: [
                        ". اتصال صفحه ی ورود و  برررسی سطح دسترسی در صفحه ورود",
                        ". اتصال نام ادمین در هدر پنل",
                        ". اتصال جزئيات ادمین در صفحه ی حساب کاربری",
                        ". اتصال تغییر نام کاربری در صفحه حساب کاربری",
                        ". اتصال تغییر رمز عبور در صفحه حساب کاربری",
                    ]
                }, {
                    title: "🐞 اشکالات رفع شده",
                    description: [". هیچ خطایی گزارش نشده است !"]
                },
            ]
        },
    ]